module.exports = __webpack_public_path__ + "img/france-infectious-diseases-male.35d6b82e.png";